module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "epi"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "epiv"
  }, [_vm._v("\n    What did I know, what did I know of love’s austere and lonely offices?\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "eps"
  }, [_c('div', [_c('br')]), _vm._v("—Robert Hayden “Those Winter Sundays”\n  ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a16d38b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/john_9781571318169_oeb_epi_r1.vue
// module id = 69
// module chunks = 0